'use strict';

import assign from 'react/lib/Object.assign';
import RouterStateMixin from '../mixins/RouterStateMixin';
import { last } from 'underscore';
import { PropTypes } from 'react';
import { isInitialPath, replaceWith } from '../router';

const SEPARATOR = '.';

function formatPages(pages) {
  for (let i = 0; i < pages.length; i++) {
    if (!pages[i]) {
      pages[i] = 0;
    }
  }

  return pages
    .map(page => ((page || 0) + 1).toString())
    .join(SEPARATOR);
}

function parsePages(formattedPages) {
  if (!formattedPages || isInitialPath()) {
    return [];
  }

  return formattedPages
    .split(SEPARATOR)
    .map(page => page && parseInt(page - 1, 10) || undefined);
}

/**
 * Reads ?p from route query and provides methods for parsing
 * and replacing page number.
 */
const PageQueryMixin = {
  mixins: [RouterStateMixin],

  propTypes: {
    params: PropTypes.object.isRequired,
    query: PropTypes.shape({
      p: PropTypes.string
    }).isRequired
  },

  contextTypes: {
    router: PropTypes.func
  },

  componentDidMount() {
    if (isInitialPath()) {
      this._replacePageQuery(null);
    }
  },

  parsePage(groupIndex) {
    if (typeof groupIndex === 'undefined') {
      groupIndex = 0;
    }

    return parsePages(this.props.query.p)[groupIndex];
  },

  replacePage(groupIndex, page) {
    if (typeof page === 'undefined') {
      page = groupIndex;
      groupIndex = 0;
    }

    const pages = parsePages(this.props.query.p);
    pages[groupIndex] = page;

    this._replacePageQuery(pages);
  },

  _replacePageQuery(pages) {
    pages = pages || [];

    const { router: { getCurrentRoutes, getCurrentParams, getCurrentQuery } } = this.context;
    const routeName = last(getCurrentRoutes()).name;
    const params = getCurrentParams();
    let query = getCurrentQuery();

    query = assign({}, query, {
      p: formatPages(pages)
    });

    if (!pages.length) {
      delete query.p;
    }

    replaceWith(routeName, params, query);
  }
};

export default PageQueryMixin;



/** WEBPACK FOOTER **
 ** ./mixins/PageQueryMixin.js
 **/